<div class="root-container">
  <section class="mam">
    <autopilot-aside></autopilot-aside>
  </section>
  <filter [ngClass]="{ visible: filterOpen, isHidden: !filterOpen }"></filter>

  <section class="wizard" *ngIf="!!rule">
    <icn-wizard
      [header]="rule.id ? 'EDIT AUTOPILOT RULE' : 'CREATE AUTOPILOT RULE'"
      [stepTitle]="getStepsTitle()"
      [doneTitle]="getDoneTitle()"
      (onNextEvent)="onNextHandler($event)"
      (onBackEvent)="onBackHandler($event)"
      [editMode]="edit"
      (apply)="onApply()"
      [applyState]="applyState"
    >
      <icn-wizard-step
        icon="/assets/icons/pop-edit.svg"
        [name]="'RULE SETUP'"
        [description]="'Set rule name and color.'"
      >
        <icn-wizard-substep [title]="'Name and color your rule:'">
          <icn-graphics-rule-wizard-step1-substep1
            #substepContent
            [rule]="rule"
          ></icn-graphics-rule-wizard-step1-substep1>
        </icn-wizard-substep>

        <icn-wizard-substep
          [title]="'Select a graphics or a video for your rule:'"
        >
          <icn-autopilot-rule-wizard-step1-substep2
            #substepContent
            [rule]="rule"
          ></icn-autopilot-rule-wizard-step1-substep2>
        </icn-wizard-substep>
      </icn-wizard-step>

      <icn-wizard-step
        icon="/assets/icons/rule-icon.svg"
        [name]="'RECURRING DISPLAY'"
        [description]="'Base rule display and set recurring time.'"
      >
        <icn-wizard-substep [title]="'Display media based on:'">
          <icn-autopilot-rule-wizard-step2-substep1
            #substepContent
            [rule]="rule"
          ></icn-autopilot-rule-wizard-step2-substep1>
        </icn-wizard-substep>
        <icn-wizard-substep [title]="'Display graphics based on:'">
          <icn-autopilot-rule-wizard-step2-substep2
            #substepContent
            [channel]="currentChannel"
            [rule]="rule"
          ></icn-autopilot-rule-wizard-step2-substep2>
        </icn-wizard-substep>
      </icn-wizard-step>

      <icn-wizard-step
        icon="/assets/icons/calander-picker.svg"
        [name]="'PLAN RULE'"
        [description]="'Schedule when to run your rule in the planner.'"
        [beforeNextStep]="onFinish.bind(this)"
      >
        <icn-wizard-substep [title]="'Plan your rule to run automatically:'">
          <icn-autopilot-rule-wizard-step3-substep1
            #substepContent
            [rule]="rule"
          ></icn-autopilot-rule-wizard-step3-substep1>
        </icn-wizard-substep>
      </icn-wizard-step>

      <icn-wizard-step [isDoneStep]="true">
        <icn-wizard-substep
          [title]="
            'Your rule was successfuly created and automatically added to your planner.\n\nGo Ahead and check it out.'
          "
        >
          <icn-autopilot-rule-wizard-done
            #substepContent
          ></icn-autopilot-rule-wizard-done>
        </icn-wizard-substep>
      </icn-wizard-step>
    </icn-wizard>
  </section>
</div>
